module.exports = __webpack_public_path__ + "img/welcome-2.0770edc2.png";